const COLOR_PALETTE = {
    transparent: "transparent",
    white: "#FFFFFF",
    // shades of grey
    slateGreyDark60: "#181F24",
    slateGreyDark50: "#20282F",
    slateGrey100: "#425563",
    slateGrey80: "#687782",
    slateGrey60: "#8E99A1",
    slateGrey40: "#B3BBC1",
    slateGrey20: "#D9DDE0",
    slateGrey10: "#ECEEEF",
    slateGrey5: "#F5F6F7",
    // greeny-bop happyco
    greenDark20: "#008358",
    greenDark10: "#009E6A",
    green100: "#00C389",
    green60: "#66DBB8",
    green30: "#B3EDDC",
    green20: "#D8F5ED",
    green10: "#E6F9F3",
    // blue manage
    blueDark20: "#2F619C",
    blueDark10: "#3B79C2",
    blue100: "#4A90E2",
    blue60: "#92BCEE",
    blue30: "#DBE9F9",
    blue10: "#F1F7FD",
    // nextgen blurple
    blurpleDark60: "#232A5C",
    blurpleDark20: "#4f49CC",
    blurpleDark10: "#5952E6",
    blurple100: "#635BFF",
    blurple60: "#A19DFF",
    blurple30: "#D0CEFF",
    blurple10: "#EFEFFF",
    // bright blue optigo
    optiBlueDark60: "#004258",
    optiBlueDark20: "#0083B1",
    optiBlueDark10: "#0094C7",
    optiBlue100: "#21A3DC",
    optiBlue60: "#66C8EB",
    optiBlue30: "#B3E4F5",
    optiBlue10: "#E5F6FC",
    // orange tasks
    orangeDark10: "#DB4B0D",
    orange100: "#FF7033",
    orange60: "#FFA985",
    orange30: "#FFD4C2",
    orange10: "#FFF1EB",
    // red
    redDark20: "#A81F1F",
    redDark10: "#D74C3F",
    red100: "#EB3D3D",
    red60: "#F38B8B",
    red30: "#F9C5C5",
    red20: "#FBD9D9",
    red10: "#FDECEC",
    // yellow
    yellowDark20: "#CC8834",
    yellowDark10: "#E6993A",
    yellow100: "#FFAA41",
    yellow60: "#FFCC8D",
    yellow30: "#FFE6C6",
    yellow20: "#FFEFDA",
    yellow10: "#FFF7EC",
    // misc colors
    purple100: "#7D55C7",
    purple60: "#B199DD",
    purple30: "#D8CCEE",
    purple20: "#EAE4F6",
    purple10: "#F2EEF9",
    // brand teal
    teal100: "#00B4BB",
    teal60: "#66D2D6",
    teal30: "#B3E9EB",
    teal10: "#E6F7F8",
    // brand emerald
    emerald100: "#008586",
    emerald60: "#66B6B6",
    emerald30: "#B3DADB",
    emerald10: "#E6F3F3"
};

export { COLOR_PALETTE };
